import { ModuleWithProviders, NgModule, inject } from '@angular/core';
import { StorageService } from './storage.service';

@NgModule()
export class StorageModule {
  constructor() {
    const module = inject(StorageModule, { optional: true, skipSelf: true });

    if (module) {
      throw new Error(`${StorageModule.name} should be imported only once!`);
    }
  }

  static forRoot(): ModuleWithProviders<StorageModule> {
    return {
      ngModule: StorageModule,
      providers: [StorageService],
    };
  }
}
